import React, { useState } from "react";
import {
  Button,
  IconCurrency,
  IconInfo,
  IconWarningAlt,
  IconNote,
  Modal,
  ProgressIndicator,
  IconUndo,
  Tooltip as VeneerTooltip,
} from "@veneer/core";
import moment from "moment";
import {
  numberFormatComma,
  numberFormatCommaTwoFraction,
} from "../../../common/js/utils/numberFormat";
import {
  LineChart,
  Line,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
} from "recharts";
import { Trans } from "react-i18next";
import { Col, Container, Row } from "reactstrap";
import { useTranslation } from "react-i18next";
import ConnectAPI from "../../../services/api";
import Swal from "sweetalert2";
import SpecialConditionDetail from "../SpecialConditionApproval/SpecialConditionDetailAll";
import $ from "jquery";

const connectApi = new ConnectAPI();

const RenderPrintVolumeReport = (props) => {
  const { consolidatePrintVolumeReport, isLoading, series4 } = props;
  return (
    <div className="col col-lg-6 col-md-12 col-sm-12">
      <div className="card mb-3 box-shadow">
        <div className="card-header text-center">
          <h5>
            <Trans i18nKey="pritnvolrep" />
          </h5>
        </div>
        <div>
          {isLoading ? (
            <ProgressIndicator appearance="linear" />
          ) : (
            <div className="table-responsive">
              <table className="table table-striped table-hover table-bordered table-sm">
                <thead>
                  <tr>
                    <th scope="col">
                      <Trans i18nKey="press id" />
                    </th>
                    <th scope="col">
                      <Trans i18nKey="totalprintedimp" />
                    </th>
                    <th scope="col">1SEP</th>
                    <th scope="col">2SEP</th>
                    <th scope="col">EPM</th>
                    {series4 && (
                      <th scope="col">
                        <Trans i18nKey="blacks4" />
                      </th>
                    )}
                    {series4 && (
                      <th scope="col">
                        <Trans i18nKey="whites4" />
                      </th>
                    )}
                  </tr>
                </thead>

                <tbody>
                  {consolidatePrintVolumeReport.map((row) => (
                    <tr key={row.idPress}>
                      {row.idPress != "Total" ? (
                        <>
                          <td align="right">{row.idPress}</td>
                          <td align="right">
                            {row.tpiPeriodTotal == null
                              ? "-"
                              : numberFormatComma(row.tpiPeriodTotal)}
                          </td>
                          <td align="right">
                            {row.oneColPeriodTotal == null
                              ? "-"
                              : numberFormatComma(row.oneColPeriodTotal)}
                          </td>
                          <td align="right">
                            {row.calcTwoColPeriodTotal == null
                              ? "-"
                              : numberFormatComma(row.calcTwoColPeriodTotal)}
                          </td>
                          <td align="right">
                            {row.epmPeriodTotal == null
                              ? "-"
                              : numberFormatComma(row.epmPeriodTotal)}
                          </td>
                          {series4 && (
                            <td align="right">
                              {row.blackS4 == null
                                ? "-"
                                : numberFormatComma(row.blackS4)}
                            </td>
                          )}
                          {series4 && (
                            <td align="right">
                              {row.whiteS4 == null
                                ? "-"
                                : numberFormatComma(row.whiteS4)}
                            </td>
                          )}
                        </>
                      ) : (
                        <>
                          {" "}
                          <th>{row.idPress}</th>
                          <th className="text-right">
                            {row.tpiPeriodTotal == null
                              ? "-"
                              : numberFormatComma(row.tpiPeriodTotal)}
                          </th>
                          <th className="text-right">
                            {row.oneColPeriodTotal == null
                              ? "-"
                              : numberFormatComma(row.oneColPeriodTotal)}
                          </th>
                          <th className="text-right">
                            {row.calcTwoColPeriodTotal == null
                              ? "-"
                              : numberFormatComma(row.calcTwoColPeriodTotal)}
                          </th>
                          <th className="text-right">
                            {row.epmPeriodTotal == null
                              ? "-"
                              : numberFormatComma(row.epmPeriodTotal)}
                          </th>
                          {series4 && (
                            <th className="text-right">
                              {row.blackS4 == null
                                ? "-"
                                : numberFormatComma(row.blackS4)}
                            </th>
                          )}
                          {series4 && (
                            <th className="text-right">
                              {row.whiteS4 == null
                                ? "-"
                                : numberFormatComma(row.whiteS4)}
                            </th>
                          )}
                        </>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const RenderSpecialCondition = (props) => {
  const { consolidatePrintVolumeReport, isLoading, series4, dateSelected , loadDatesSelect} = props;
  const [specialConditionDetail, setSpecialConditionDetail] = useState([]);
  const [idSpecialContion, setIdSpecialCondtion] = useState([]);
  const [showSCDetail, setShowSCDetail] = useState(false);
  const { t, i18n } = useTranslation();
  const createClickHandler = (e) => {
    var id = $(e.target).closest('tr').children().eq(0).text();

    const fetchData = () => {
      let data={
        date:dateSelected,
        idpress:id,
      }
      connectApi.post(
        'api/Channels/specialConditionbyidpress',
        data,
        consolid_SC
      );
    };
    const consolid_SC= (status, data) => {
      if (data.length>0){
        setSpecialConditionDetail(data[0]);
        setShowSCDetail(true);
      }else{
        Swal.fire(
          "Error ",
          t("NoDatasc"),
          "error"
        );
      }
      
    }

    fetchData();
  };

  const hideSCDetailsModal = () => {
    setShowSCDetail(false);
  }
  const saveSpecialCondition=()=>{}

  return (
    <div className="col col-lg-6 col-md-12 col-sm-12">
      <div className="card mb-3 box-shadow">
        <div className="card-header text-center">
          <h5>
            <Trans i18nKey="specialconditions" />
          </h5>
        </div>
        <div>
          {isLoading ? (
            <ProgressIndicator appearance="linear" />
          ) : (
            <div className="table-responsive">
              <table className="table table-striped table-hover table-bordered table-sm">
                <thead>
                  <tr>
                    <th scope="col">
                      <Trans i18nKey="press id" />
                    </th>
                    <th scope="col">
                      <Trans i18nKey="duedate" />
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {consolidatePrintVolumeReport.map((row) => {
                    if (row.idPress === "Total" || row.endDate == null) {
                      return undefined;
                    }
                    return (
                      <tr onClick={createClickHandler} key={row.idPress}>
                        <td align="right">{row.idPress}</td>
                        <td align="right">
                          {row.endDate == null
                            ? "-"
                            : moment(row.endDate).format("DD/MMM/YYYY")}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
      <SpecialConditionDetail idSpecialCondition={idSpecialContion} onShowModal={showSCDetail} confirmationFunction={saveSpecialCondition} onCloseSCDetailsModal={hideSCDetailsModal} SpecialConditionDetail={specialConditionDetail} dateSelectedCC={dateSelected} />
    </div>
  );
};

const RenderEmptyCard = (props) => {
  return (
    <div className="col col-lg-6 col-md-12 col-sm-12">
      <div className="card mb-3 box-shadow">
        {/* <div className="card-header text-center">
          <h5>Special Conditions</h5>
        </div> */}
        <div>
          {/* {isLoading ? (
            <ProgressIndicator size={72} className="block-center" />
          ) : (
            <div className="table-responsive">
              <table className="table table-striped table-hover table-bordered table-sm">
                <thead>
                  <tr>
                    <th scope="col">Press Id</th>
                    <th scope="col">Due Date</th>
                  </tr>
                </thead>
                <tbody>
                  {consolidatePrintVolumeReport.map((row) => {
                    if (row.idPress === 'Total' || row.endDate == null) {
                      return undefined;
                    }
                    return (
                      <tr key={row.idPress}>
                        <td align="right">{row.idPress}</td>
                        <td align="right">
                          {row.endDate == null
                            ? '-'
                            : moment(row.endDate).format('DD/MMM/YYYY')}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )} */}
        </div>
      </div>
    </div>
  );
};

const RenderSuppliesBonus = (props) => {
  const {
    suppliesBonus,
    isLoading,
    series4,
    logs,
    dateSelected,
    setLogs,
    loadDatesSelect,
    reportDates,
    endUser,
  } = props;
  const [sending, setSending] = useState(false);
  const { t, i18n } = useTranslation();
  const currentUser = JSON.parse(localStorage.getItem("currentUser"));

  const filteredDate = reportDates.filter((item) => {
    return (
      parseInt(moment(item.date).format("M")) == dateSelected.month &&
      parseInt(moment(item.date).format("YYYY")) == dateSelected.year
    );
  });
 
  const shouldConsiderBonus = filteredDate[0].shouldConsiderBonus;

  function getBonusStatus() {
    const dateSelectedLogs = logs.filter((log) => {
      return (
        log.month == dateSelected.month &&
        log.year == dateSelected.year &&
        (log.actionDescription == "Bonus Accepted" ||
          log.actionDescription == "Bonus Issue Raised")
      );
    });

    if (dateSelectedLogs.length == 0) return "No Logs";

    return dateSelectedLogs[0].actionDescription;
  }
  function getBonusPayDate() {
    const dateSelectedLogs = logs.filter((log) => {
      return (
        log.month == dateSelected.month &&
        log.year == dateSelected.year &&
        (log.actionDescription == "Bonus Received Confirmation" )
      );
    });

    if (dateSelectedLogs.length == 0) return "No Logs";

    return dateSelectedLogs[0].date;
  }
  function getBonusAceptDate() {
    const dateSelectedLogs = logs.filter((log) => {
      return (
        log.month == dateSelected.month &&
        log.year == dateSelected.year &&
        (log.actionDescription == "Bonus Accepted" ||
          log.actionDescription == "Bonus Issue Raised")
      );
    });

    if (dateSelectedLogs.length == 0) return "No Logs";

    return dateSelectedLogs[0].date;
  }
  function getBonusAcceptUser() {
    const dateSelectedLogs = logs.filter((log) => {
      return (
        log.month == dateSelected.month &&
        log.year == dateSelected.year &&
        (log.actionDescription == "Bonus Accepted" ||
          log.actionDescription == "Bonus Issue Raised")
      );
    });

    if (dateSelectedLogs.length == 0) return "No Logs";

    return dateSelectedLogs[0].idUser;
  }
  function getBonusPayName() {
    const dateSelectedLogs = logs.filter((log) => {
      return (
        log.month == dateSelected.month &&
        log.year == dateSelected.year &&
        (log.actionDescription == "Bonus Received Confirmation")
      );
    });

    if (dateSelectedLogs.length == 0) return "No Logs";

    return dateSelectedLogs[0].idUser;
  }
 
  const bonusStatus = getBonusStatus();
  const bonusacceptDate=getBonusAceptDate();
  const bonusacceptUser=getBonusAcceptUser();
  const bonusPayDate=getBonusPayDate();
  const bonusPayName=getBonusPayName();
  /* modify for accrual */
  function getBonusAccrual(){
    const dateSelectedLogs = logs.filter((log) => {
      return (
        log.month == dateSelected.month &&
        log.year == dateSelected.year &&
        (log.actionDescription == "Bonus Accrual Released")
      );
    });
    if (dateSelectedLogs.length == 0) return "No Logs";

    return dateSelectedLogs[0].idUser;
  }
  function getBonusAccrualDate(){
    const dateSelectedLogs = logs.filter((log) => {
      return (
        log.month == dateSelected.month &&
        log.year == dateSelected.year &&
        (log.actionDescription == "Bonus Accrual Released")
      );
    });

    if (dateSelectedLogs.length == 0) return "No Logs";

    return dateSelectedLogs[0].date;
  }
  const bonusAccrual=getBonusAccrual();
  const bonusAccrualDate=getBonusAccrualDate();
  /* en modify */
  function acceptBonus() {
    setSending(true);

    const handleResponse = () => {
      setSending(false);
      const newLog = {
        month: dateSelected.month,
        year: dateSelected.year,
        actionDescription: "Bonus Accepted",
      };

      let newLogs = [...logs];
      newLogs.unshift(newLog);

      setLogs(newLogs);

      //update reportDates
      const currentDateIdx = reportDates.findIndex(x => parseInt(moment(x.date).format("M")) == dateSelected.month && parseInt(moment(x.date).format("YYYY")) == dateSelected.year);
      reportDates[currentDateIdx].bonusAccepted = true;
      loadDatesSelect(reportDates, endUser, false);
      // loadDatesSelect(newLogs, reportDates, false, endUser);
    };

    connectApi
      .get(
        "api/Channels/insertLog",
        {
          params: {
            month: dateSelected.month,
            year: dateSelected.year,
            idEndUser: endUser.idEndUser,
            idUser: currentUser.idUser,
            actionDescription: "Bonus Accepted",
          },
        },
        handleResponse
      )
      .catch((error) => {
        Swal.fire(
          "Error " + error.response.status,
          error.response.data,
          "error"
        );
      });
  }

  let totalPrintedVol = 0;
  let totalBonusValue = 0;

  //sort non-manual adjustments first
  suppliesBonus.sort((x, y) => {
    // return x.manual === y.manual ? 0 : x.manual ? 1 : -1;
    // From: Jocks - Parche para que no reste cuando es Accrual Released
    let strX = x.comments+"";
    let strY = y.comments+"";
    if(strX.includes("Accrual Released") | strY.includes("Accrual Released") ){
      return strX.includes("Accrual Released") === strY.includes("Accrual Released") ? 0 : strY.includes("Accrual Released") ? -1 : 0;
    } else
      return x.manual === y.manual ? 0 : x.manual ? 1 : -1;
  });
  return (
    <div className="col col-lg-6 col-md-12 col-sm-12">
      <div className="card mb-3 box-shadow">
        <div className="card-header text-center">
          <h5>
            <Trans i18nKey="suppliesbonus" />
          </h5>
        </div>
        <div>
          {isLoading ? (
            <ProgressIndicator appearance="linear" />
          ) : (
            <>
              <div className="table-responsive">
                <table className="table table-striped table-hover table-bordered table-sm">
                  <thead>
                    <tr>
                      <th scope="col">
                        <Trans i18nKey="press id" />
                      </th>
                      <th scope="col">
                        <Trans i18nKey="printvol4colors" />
                      </th>
                      <th scope="col">
                        <Trans i18nKey="supspend" />
                      </th>
                      <th scope="col">
                        <Trans i18nKey="bonus" />
                      </th>
                      <th scope="col">
                        <Trans i18nKey="bonusvalue" />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {suppliesBonus.map((row) => {
                      totalPrintedVol += row.printedVolume4Col;
                      // From: Jocks - Parche para que no reste cuando es Accrual Released
                      let str = row.comments+"";
                      if(!str.includes("Accrual Released")){
                        totalBonusValue += row.bonusValue;
                      }
                      return !row.manual ? (
                        <tr key={row.idPress}>
                          <td align="right">{row.idPress}</td>
                          <td align="right">
                            {row.printedVolume4Col == null
                              ? "-"
                              : numberFormatComma(row.printedVolume4Col)}
                          </td>
                          <td align="right">
                            {row.suppliesSpent == null
                              ? "-"
                              : numberFormatCommaTwoFraction(row.suppliesSpent)}
                          </td>
                          <td align="center">
                            {row.bonus == null
                              ? "-"
                              : numberFormatCommaTwoFraction(row.bonus)}
                            %
                          </td>
                          <td align="right">
                            {row.bonusValue == null
                              ? "-"
                              : numberFormatCommaTwoFraction(row.bonusValue)}
                          </td>
                        </tr>
                      ) : ( row.comments ? ( str.includes("Accrual Released") ? ( 
                        <tr style={{ backgroundColor: "#e7fffb"}}>
                          <th colSpan="4">
                            <VeneerTooltip
                              content="Accrual Released"
                              id="tooltip-default0"
                              contentHideDelayOnHover={0}
                            >
                              <IconUndo size={17} style={{ marginRight: '5px'}}/>
                            </VeneerTooltip>
                            {row.comments + " " +
                              (row.idPress != null
                                ? t("forPress") + row.idPress
                                : " ")}
                          </th>
                          <td align="right">
                            {numberFormatCommaTwoFraction(row.bonusValue)}
                          </td>
                        </tr> ) : row.type == 'Program' ? (<tr style={{ backgroundColor: "#9fe5ff" }}>
                          <th colSpan="4">
                            <VeneerTooltip
                              content="Program"
                              id="tooltip-default1"
                              contentHideDelayOnHover={0}
                            >
                              <IconCurrency size={17} style={{ marginRight: '5px'}}/>
                            </VeneerTooltip>
                            {row.comments + " " +
                              (row.idPress != null
                                ? t("forPress") + row.idPress
                                : " ")}
                          </th>
                          <td align="right">
                            {numberFormatCommaTwoFraction(row.bonusValue)}
                          </td>
                        </tr>) : ( <tr style={{ backgroundColor: "#ebf9ff" }}>
                          <th colSpan="4">
                            <VeneerTooltip
                              content="Adjustment"
                              id="tooltip-default2"
                              contentHideDelayOnHover={0}
                            >
                              <IconNote size={18} style={{ marginRight: '4px'}}/>
                            </VeneerTooltip>
                            {row.comments + " " +
                              (row.idPress != null
                                ? t("forPress") + row.idPress
                                : " ")}
                          </th>
                          <td align="right">
                            {numberFormatCommaTwoFraction(row.bonusValue)}
                          </td>
                        </tr>)
                      ):(
                        <tr style={{ backgroundColor: "#ebf9ff" }}>
                          <th colSpan="4">
                            {t("adjustments") +
                              (row.idPress != null
                                ? t("forPress") + row.idPress + " "
                                : " ")}
                            <VeneerTooltip placement="top" contentHideDelayOnHover={0} content={row.comments || t('noComments')}>
                              <IconInfo size={16} />
                            </VeneerTooltip>
                          </th>
                          <td align="right">
                            {numberFormatCommaTwoFraction(row.bonusValue)}
                          </td>
                        </tr>
                      ));
                    })}
                    <tr key="total">
                      <th>Total</th>
                      <th className="text-right">
                        {numberFormatComma(totalPrintedVol)}
                      </th>
                      <th className="text-right">--</th>
                      <th className="text-center">--</th>
                      <th className="text-right">
                        {numberFormatCommaTwoFraction(totalBonusValue)}
                      </th>
                    </tr>
                  </tbody>
                </table>
              </div>
              {(bonusAccrual!="No Logs")?(
                <><b>{t("AccrualBonus")} {bonusAccrual} {moment(bonusAccrualDate).format("DD/MMM/YYYY")}</b> <br/>
                {(bonusStatus == "Bonus Accepted") ? (
                    <><b>{t("acceptDate")} {bonusacceptUser} {moment(bonusacceptDate).format("DD/MMM/YYYY")}</b> <br/>
                      {bonusPayDate=="No Logs"?(''):(
                        <><b>{t("PayBonus")} {bonusPayName} {moment(bonusPayDate).format("DD/MMM/YYYY")}</b></>
                      )}
                    </>
                  ):( "" )}
                </>
              ):(<>
                {(bonusStatus == "Bonus Accepted") ? (
                  <><b>{t("acceptDate")} {bonusacceptUser} {moment(bonusacceptDate).format("DD/MMM/YYYY")}</b> <br/>
                    {bonusPayDate=="No Logs"?(''):(
                      <><b>{t("PayBonus")} {bonusPayName} {moment(bonusPayDate).format("DD/MMM/YYYY")}</b></>
                    )}
                  </>
                ):("")}</>
              )}
              {!shouldConsiderBonus ? ("") : (
                (currentUser.idRole == 12 || currentUser.idRole == 11 )?(
                  <Container>
                    <Row>
                      <Col xs="6" style={{ padding: "0px" }}>
                        {!(bonusStatus == "Bonus Issue Raised") ||
                          bonusStatus == "Bonus Accepted" ? (
                          ""
                        ) : (
                          <>
                            <IconWarningAlt filled color="colorRed6" size={24} />
                            <label style={{ fontWeight: "bold" }}>
                              {t("issueReportedByUser")}
                            </label>
                          </>
                        )}
                      </Col>
                      <Col xs="6" style={{ padding: "0px" }}>
                        {bonusStatus == "Bonus Accepted" ? (
                          ""
                        ) : (
                          <>
                            {bonusStatus == "Bonus Issue Raised" ? (
                              ""
                            ) : (
                              <>
                                <Button
                                  className="neutral-button"
                                  style={{
                                    fontSize: "13px",
                                    padding: "4px 8px",
                                    float: "right",
                                    marginLeft: "4px",
                                  }}
                                  onClick={() =>
                                    props.setShowBonusIssueModal(true)
                                  }
                                  loading={sending}
                                >
                                  {t("reportIssue")}
                                </Button>
                              </>
                            )}
                            <Button
                              appearance="success"
                              style={{
                                fontSize: "13px",
                                padding: "4px 8px",
                                float: "right",
                              }}
                              onClick={acceptBonus}
                              loading={sending}
                            >
                              {bonusStatus == "Bonus Issue Raised"
                                ? t("acceptBonus") + ", " + t("issueSolved")
                                : t("acceptBonus")}
                            </Button>
                          </>
                        )}
                      </Col>
                    </Row>
                  </Container>
                ):("")
                
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

const RenderSuppliesCompensation = (props) => {
  const {
    suppliesCompensation,
    isLoading,
    logs,
    dateSelected,
    setLogs,
    loadDatesSelect,
    reportDates,
    endUser,
  } = props;
  const [sending, setSending] = useState(false);
  const currentUser = JSON.parse(localStorage.getItem("currentUser"));

  const filteredDate = reportDates.filter((item) => {
    return (
      parseInt(moment(item.date).format("M")) == dateSelected.month &&
      parseInt(moment(item.date).format("YYYY")) == dateSelected.year
    );
  });

  const shouldConsiderCompensation = filteredDate[0].shouldConsiderCompensation;
  
  const filteredData=reportDates.filter(x=>x.shouldConsiderCompensation==true);
  
  const isLastDatePublished =
    parseInt(moment(filteredData[0].date).format("M")) == dateSelected.month &&
    parseInt(moment(filteredData[0].date).format("YYYY")) == dateSelected.year;

  /*const isLastDatePublished =
    parseInt(moment(reportDates[0].date).format("M")) == dateSelected.month &&
    parseInt(moment(reportDates[0].date).format("YYYY")) == dateSelected.year;
  */
  const { t, i18n } = useTranslation();

  function getCompStatus() {
    const dateSelectedLogs = logs.filter((log) => {
      return (
        log.month == dateSelected.month &&
        log.year == dateSelected.year &&
        (log.actionDescription == "Compensation Accepted" ||
          log.actionDescription == "Compensation Issue Raised")
      );
    });

    if (dateSelectedLogs.length == 0) return "No Logs";

    return dateSelectedLogs[0].actionDescription;
  }

  const compStatus = getCompStatus();

  function getCompensationDateUser() {
    const dateSelectedLogs = logs.filter((log) => {
      return (
        log.month == dateSelected.month &&
        log.year == dateSelected.year &&
        (log.actionDescription == "Compensation Accepted" ||
          log.actionDescription == "Compensation Issue Raised")
      );
    });

    if (dateSelectedLogs.length == 0) return "No Logs";

    return dateSelectedLogs[0].date;
  }
  function getCompensationAcceptUser() {
    const dateSelectedLogs = logs.filter((log) => {
      return (
        log.month == dateSelected.month &&
        log.year == dateSelected.year &&
        (log.actionDescription == "Compensation Accepted" ||
          log.actionDescription == "Compensation Issue Raised")
      );
    });

    if (dateSelectedLogs.length == 0) return "No Logs";

    return dateSelectedLogs[0].idUser;
  }
  const compensationAcceptUser=getCompensationAcceptUser();
  const compensationDateUser=getCompensationDateUser();

  function acceptCompensation() {
    setSending(true);

    const handleResponse = () => {
      setSending(false);
      const newLog = {
        month: dateSelected.month,
        year: dateSelected.year,
        actionDescription: "Compensation Accepted",
      };

      let newLogs = [...logs];
      newLogs.unshift(newLog);

      setLogs(newLogs);

      //update reportDates
      const currentDateIdx = reportDates.findIndex(x => parseInt(moment(x.date).format("M")) == dateSelected.month && parseInt(moment(x.date).format("YYYY")) == dateSelected.year);
      reportDates[currentDateIdx].compensationAccepted = true;
      loadDatesSelect(reportDates, endUser, false);
      // loadDatesSelect(newLogs, reportDates, false, endUser);
    };

    connectApi
      .get(
        "api/Channels/insertLog",
        {
          params: {
            month: dateSelected.month,
            year: dateSelected.year,
            idEndUser: endUser.idEndUser,
            idUser: currentUser.idUser,
            actionDescription: "Compensation Accepted",
          },
        },
        handleResponse
      )
      .catch((error) => {
        Swal.fire(
          "Error " + error.response.status,
          error.response.data,
          "error"
        );
      });
  }
  
  let totalPrintedVol = 0;
  let totalCompensationValue = 0;

  //sort non-manual adjustments first
  suppliesCompensation.sort((x, y) => {
    //return x.manual === y.manual ? 0 : x.manual ? 1 : -1;
    // From: Jocks - Parche para que no reste cuando es Accrual Released
    let strX = x.comments+"";
    let strY = y.comments+"";
    if(strX.includes("Accrual Released") | strY.includes("Accrual Released") ){
      return strX.includes("Accrual Released") === strY.includes("Accrual Released") ? 0 : strY.includes("Accrual Released") ? -1 : 0;
    } else
      return x.manual === y.manual ? 0 : x.manual ? 1 : -1;
  });
  return (
    <div className="col col-lg-6 col-md-12 col-sm-12">
      <div className="card mb-3 box-shadow">
        <div className="card-header text-center">
          <h5>
            <Trans i18nKey="suppliescomp" />
          </h5>
        </div>
        <div>
          {isLoading ? (
            <ProgressIndicator appearance="linear" />
          ) : (
            <>
              <div className="table-responsive">
                <table className="table table-striped table-hover table-bordered table-sm">
                  <thead>
                    <tr>
                      <th scope="col">
                        <Trans i18nKey="press id" />
                      </th>
                      <th scope="col">
                        <Trans i18nKey="supspend" />
                      </th>
                      <th scope="col">
                        <Trans i18nKey="compvalue" />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {suppliesCompensation.map((row) => {
                      totalPrintedVol += row.printedVolume4Col;
                      // From: Jocks - Parche para que no reste cuando es Accrual Released
                      let str = row.comments+"";
                      if(!str.includes("Accrual Released")){
                        totalCompensationValue += row.compensationValue;
                      }
                      return !row.manual ? (
                        <tr key={row.idPress}>
                          <td align="right">{row.idPress}</td>
                          <td align="right">
                            {row.suppliesSpent == null
                              ? "-"
                              : numberFormatComma(row.suppliesSpent)}
                          </td>
                          <td align="right">
                            {row.compensationValue == null
                              ? "-"
                              : numberFormatCommaTwoFraction(
                                row.compensationValue
                              )}
                          </td>
                        </tr>
                      ) : (row.comments ? ( str.includes("Accrual Released") ? ( 
                        <tr style={{ backgroundColor: "#e7fffb"}}>
                          <th colSpan="2">
                            {row.comments + " " +
                              (row.idPress != null
                                ? t("forPress") + row.idPress
                                : " ")}
                          </th>
                          <td align="right">
                            {numberFormatCommaTwoFraction(row.compensationValue)}
                          </td>
                        </tr> ) : ( <tr style={{ backgroundColor: "#ebf9ff" }}>
                          <th colSpan="2">
                            {row.comments + " " +
                              (row.idPress != null
                                ? t("forPress") + row.idPress
                                : " ")}
                          </th>
                          <td align="right">
                            {numberFormatCommaTwoFraction(row.compensationValue)}
                          </td>
                        </tr>)
                      ):(
                        <tr style={{ backgroundColor: "#ebf9ff" }}>
                          <th colSpan="2">
                            {t("adjustments") +
                              (row.idPress != null
                                ? t("forPress") + row.idPress + " "
                                : " ")}
                            <VeneerTooltip placement="top" contentHideDelayOnHover={0} content={row.comments || t('noComments')}>
                              <IconInfo size={16} />
                            </VeneerTooltip>
                          </th>
                          <td align="right">
                            {numberFormatCommaTwoFraction(
                              row.compensationValue
                            )}
                          </td>
                        </tr>
                      ));
                    })}
                    <tr key="total">
                      <th>Total</th>
                      <th className="text-right">--</th>
                      <th className="text-right">
                        {numberFormatCommaTwoFraction(totalCompensationValue)}
                      </th>
                    </tr>
                  </tbody>
                </table>
                {
                   (compStatus == "Compensation Accepted") ? (
                    <><b>{t("acceptDate")} {compensationAcceptUser} {moment(compensationDateUser).format("DD/MMM/YYYY")}</b></>
                  ):( "" )
                }
              </div>
              {/* 
                  Users who can accept compensation and see statement button:
                    - End users whose group != 2
                    - Customers whose enduser's group == 2
                  Only when:
                    - Compensation should be considered or 
                    - Selected date is last date published              
               */}
              {!(
                (endUser.group != 2 &&
                  (currentUser.idRole == 12 || currentUser.idRole == 11)) ||
                (((endUser.group == 2 &&
                  (currentUser.idRole == 9 || currentUser.idRole == 10)) ||
                  [1, 6, 8,5].findIndex((role) => role == currentUser.idRole) >
                  -1) &&
                  (shouldConsiderCompensation || isLastDatePublished))
              ) ? (
                ""
              ) : (
                
                <Container>
                
                  <Row>
                    <Col xs="6" style={{ padding: "0px" }}>
                      {!(compStatus == "Compensation Issue Raised") ||
                        compStatus == "Compensation Accepted" ? (
                          ""
                      ) : (
                        <>
                          <IconWarningAlt filled color="colorRed6" size={24} />
                          <label style={{ fontWeight: "bold" }}>
                            {t("issueReportedByUser")}
                          </label>
                        </>
                      )}
                    </Col>
                    <Col xs="6" style={{ padding: "0px" }}>
                      {compStatus == "Compensation Accepted" ||
                        (!shouldConsiderCompensation && isLastDatePublished) ||
                        (isLastDatePublished &&
                          [1, 6, 8].findIndex(
                            (role) => role == currentUser.idRole
                          ) > -1) ? (
                        props.renderStatementButton && isLastDatePublished ? (
                          <Button
                            style={{
                              fontSize: "13px",
                              padding: "4px 8px",
                              float: "right",
                            }}
                            onClick={() => props.handleStatementReport()}
                          >
                            {t("button.statement")}
                          </Button>
                        ) : (
                          ""
                        )
                      ) : (endUser.group != 2 && (currentUser.idRole == 11 || currentUser.idRole == 12)) || (endUser.group == 2 && (currentUser.idRole == 9 || currentUser.idRole == 10)) ? (
                        <>
                          {compStatus == "Compensation Issue Raised" ? (
                            ""
                          ) : (
                            <>
                              <Button
                                className="neutral-button"
                                style={{
                                  fontSize: "13px",
                                  padding: "4px 8px",
                                  float: "right",
                                  marginLeft: "4px",
                                }}
                                onClick={() =>
                                  props.setShowCompensationIssueModal(true)
                                }
                                loading={sending}
                              >
                                {t("reportIssue")}
                              </Button>
                            </>
                          )}
                          <Button
                            appearance="success"
                            style={{
                              fontSize: "13px",
                              padding: "4px 8px",
                              float: "right",
                            }}
                            onClick={acceptCompensation}
                            loading={sending}
                          >
                            {compStatus == "Compensation Issue Raised"
                              ? t("acceptCompensation") +
                              ", " +
                              t("issueSolved")
                              : t("acceptCompensation")}
                          </Button>
                        </>
                      ) : undefined
                      }
                    </Col>
                  </Row>
                </Container>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

const RenderCreditNoteManualAdjustments = (props) => {
  const { t } = useTranslation();

  return (
    <div className="col col-lg-6 col-md-12 col-sm-12">
      <div className="card mb-3 box-shadow">
        <div className="card-header text-center">
          <h5>{t('manualAdjustments')}</h5>
        </div>
        <div>
          {props.isLoading ? (
            <ProgressIndicator appearance="linear" />
          ) : (
            <>
              <div className="table-responsive">
                <table className="table table-striped table-hover table-bordered table-sm">
                  <thead>
                    <tr>
                      <th scope="col">{t('concept')}</th>
                      <th scope="col">{t('credit note')} (USD$)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {props.creditNoteAdjustment.map((row) => {
                      return (
                        <>
                          <tr>
                            <td align="right">{row.comments}</td>
                            <td align="right">{numberFormatCommaTwoFraction(row.creditNote)}</td>
                          </tr>
                        </>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

const RenderChart = (props) => {
  const { t, i18n } = useTranslation();
  const {
    dateSelected,
    costPerPrintEvolution,
    showChartModal,
    closeChartModal,
  } = props;

  /*let dataValues = costPerPrintEvolution.map((item) => {
    return { name: moment(item.date).format("MMM/YYYY") };
  });
  function getUnique(dataValues, comp) {
    // store the comparison  values in array
    const unique = dataValues
      .map((e) => e[comp])
      // store the indexes of the unique objects
      .map((e, i, final) => final.indexOf(e) === i && i)
      // eliminate the false indexes & return unique objects
      .filter((e) => dataValues[e])
      .map((e) => dataValues[e]);
    return unique;
  }
  let dataValuesOk = getUnique(dataValues, "name").reverse();
  let presses = [];
  //Declare this variable to compare when idPress change
  let lastIdPress = "";
  //Declare this varibale to Count the numeber of items in costPerPrintEvolution
  let count = 0;
  //Declare this auxiliar variable
  let costPerPrintEvoulution_ = [];
  if (costPerPrintEvolution.length > 0) {
    costPerPrintEvoulution_ = costPerPrintEvolution.reverse();
  }
  //costPerPrintEvolution = costPerPrintEvolution.reverse()
  costPerPrintEvoulution_.map((item, index) => {
    if (index != 0) {
      if (item.idPress != lastIdPress) {
        count = 0;
      }
    }
    presses = [...presses, item.idPress];
    dataValuesOk[count][`${item.idPress}`] = item.costPerPrint;
    lastIdPress = item.idPress;
    count++;
  });
  const distinct = (value, index, self) => {
    return self.indexOf(value) === index;
  };
  presses = presses.filter(distinct);
  dataValuesOk = dataValuesOk.reverse();
  console.log(dataValuesOk);
  console.log(presses);*/

  function onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }
  let dates_data=costPerPrintEvolution.map(item=>item.date).filter(onlyUnique);
  let presses = costPerPrintEvolution.map(item=>item.idPress).filter(onlyUnique);
  let dataValuesOk=[];
  let count=0;
  dates_data.forEach(element => {
      let rows=costPerPrintEvolution.filter((item) => item.date === element);
      dataValuesOk.push({'name':moment(element).format("DD/MMM/YYYY")});
      rows.forEach(less => {
        dataValuesOk[count][`${less.idPress}`]= less.costPerPrint
      });
      count++
  });
  dataValuesOk.sort((a,b)=>{
    return new Date(a.name).getTime()-new Date(b.name).getTime();
  });

  const colors = [
    "#e34262",
    "#5ac18e",
    "#0ba2fe",
    "#f1b10a",
    "#004bff",
    "#a76fff",
    "#810b46",
    "#eea6e6",
    "#100b46",
    "#307060",
    "#a7ff55",
  ];
  const chart = (
    <LineChart
      width={600}
      height={300}
      data={dataValuesOk}
      margin={{ top: 5, right: 20, bottom: 5, left: 30 }}
    >
      {presses.map((item, index) => {
        return (
          <Line
            key={item}
            type="monotone"
            activeDot={{ r: 4 }}
            dataKey={item}
            name={item}
            stroke={colors[index]}
          />
        );
      })}
      <CartesianGrid stroke="#eee" strokeDasharray="3 3" />
      <XAxis dataKey="name" />
      <YAxis />
      <Tooltip />
      <Legend />
    </LineChart>
  );

  return (
    <Modal
      title={t('printing_cost')}
      show={showChartModal}
      onClose={closeChartModal}
      size="lg"
      css={{
        ".vn-modal--content": {
          width: "710px",
        },
      }}
    >
      <div>{chart}</div>
    </Modal>
  );
};

export {
  RenderChart,
  RenderSuppliesCompensation,
  RenderSuppliesBonus,
  RenderPrintVolumeReport,
  RenderSpecialCondition,
  RenderEmptyCard,
  RenderCreditNoteManualAdjustments,
};